import React, { useState, useEffect } from 'react';
import { Check, ExternalLink, ArrowUp } from 'lucide-react';
import { cn } from '../lib/utils';

export function TermsCheckbox({ checked, onChange, highlight = false }) {
  const [showHighlight, setShowHighlight] = useState(false);

  useEffect(() => {
    if (highlight) {
      setShowHighlight(true);
      const timer = setTimeout(() => setShowHighlight(false), 4000);
      return () => clearTimeout(timer);
    }
  }, [highlight]);

  return (
    <div
      id="terms-checkbox-section"
      className={cn(
        "border rounded-xl p-4 mb-4 transition-all duration-500",
        showHighlight
          ? "bg-red-500/15 border-red-500/60 shadow-[0_0_20px_rgba(239,68,68,0.3)] animate-pulse"
          : "bg-[#0f133a]/60 border-white/10"
      )}
    >
      <label className="flex items-start gap-3 cursor-pointer">
        <button
          type="button"
          onClick={() => onChange(!checked)}
          className={cn(
            "w-5 h-5 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-all",
            checked
              ? "border-[#aa2aff] bg-[#aa2aff]"
              : showHighlight
                ? "border-red-500 bg-red-500/20"
                : "border-slate-500 hover:border-slate-400"
          )}
          data-testid="checkbox-terms"
        >
          {checked && <Check className="w-3 h-3 text-white" />}
        </button>
        
        <span className={cn("text-sm", showHighlight ? "text-white font-medium" : "text-slate-300")}>
          Acepto la{' '}
          <a 
            href="/politica-privacidad" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#aa2aff] hover:underline inline-flex items-center gap-1"
            onClick={(e) => e.stopPropagation()}
          >
            Política de Privacidad
            <ExternalLink className="w-3 h-3" />
          </a>
          {' '}y los{' '}
          <a 
            href="/terminos-condiciones" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#aa2aff] hover:underline inline-flex items-center gap-1"
            onClick={(e) => e.stopPropagation()}
          >
            Términos y Condiciones
            <ExternalLink className="w-3 h-3" />
          </a>
          {' '}de la plataforma.
        </span>
      </label>

      {showHighlight && (
        <div className="flex items-center gap-2 mt-2 ml-8">
          <ArrowUp className="w-4 h-4 text-red-400 animate-bounce" />
          <span className="text-red-400 text-xs font-semibold">Debes aceptar los términos para continuar</span>
        </div>
      )}
    </div>
  );
}

export default TermsCheckbox;
